/**
 * Folder-like silhouette clip-path used for soundkit artworks.
 * Uses full bounds (0–100%) so no space is removed from left, right, or top-left corner.
 */
export function getSoundkitClipPath(tight = false): string {
  if (tight) {
    // Tight variant: slightly smaller tab, lower fold.
    return "polygon(0% 0%, 36.8% 0%, 41.8% 6.6%, 100% 6.6%, 100% 100%, 0% 100%)";
  }
  return "polygon(0% 0%, 41.3% 0%, 46.2% 8.4%, 100% 8.4%, 100% 100%, 0% 100%)";
}
